var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.showNav)?_c('head-nav'):_vm._e(),_c('router-view'),_c('foot-nav')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }